import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@metarouter-private/mr-mui';

import auditLogPanelId from 'app/audit-logs/AuditLogModal/AuditLogPanel/auditLogPanelId';
import UnattributedMarker from 'app/audit-logs/AuditLogModal/AuditLogPanel/UnattributedMarker';
import AuditLogDerivedNote from 'app/audit-logs/AuditLogModal/AuditLogPanel/AuditLogDerivedNote';

import AuditLogFieldDiffList from './AuditLogFieldDiffList';
import AuditLogKeyValueList from './AuditLogKeyValueList';

export default function AuditLogDebugDataPanel({ data: row, formattedEntryByRowId }) {
  const entry = formattedEntryByRowId.get(row.id);
  if (!entry) return null;

  const isDiff = entry.renderMode === 'diff';

  return (
    <Stack id={auditLogPanelId(row.id)} data-test-id="auditLogDebugPanel" spacing={1.5} padding={2}>
      {entry.unattributed && <UnattributedMarker />}
      {isDiff ? <AuditLogFieldDiffList fields={entry.fields} /> : <AuditLogKeyValueList fields={entry.fields} />}
      {isDiff && <AuditLogDerivedNote />}
    </Stack>
  );
}

AuditLogDebugDataPanel.propTypes = {
  data: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  formattedEntryByRowId: PropTypes.instanceOf(Map).isRequired,
};
